export default __webpack_public_path__ + "img/_/_/views/cabinet/Feedback/assets/images/feedback.png";